import { Menu } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router";

export type MobileBottomNavItem = {
  key: string;
  label: string;
  href: string;
  icon: ReactNode;
};

export function MobileBottomNav({ items, activeKey, onMore }: { items: MobileBottomNavItem[]; activeKey: string; onMore: () => void }) {
  return (
    <nav className="ui-mobile-nav mobile-safe-bottom" aria-label="Mobile workspace">
      {items.slice(0, 3).map((item) => (
        <Link
          className="ui-mobile-nav__item"
          key={item.key}
          to={item.href}
          aria-current={activeKey === item.key ? "page" : undefined}
        >
          <span className="ui-mobile-nav__icon" aria-hidden="true">{item.icon}</span>
          <span>{item.label}</span>
        </Link>
      ))}
      <button className="ui-mobile-nav__item" type="button" onClick={onMore}>
        <Menu aria-hidden="true" size={20} />
        <span>More</span>
      </button>
    </nav>
  );
}
